import _ from 'lodash';
import SelectedAttributeOption from '../../state/selectedOptionValue';

//export type merchantProductOptionsType = variantsQuery$data["merchantProductOptions"]

export type merchantProductOptionType = {
    salesChannelID?: number;
    isGlobal: boolean;
    label: string;
    optionID: string;
    values: {
        label: string;
        valueID: string;
    }[];
};

export type ColorAttribute = {
    Id: string;
    Label: string;
    Value: {
        Id: string;
        Label: string;
    };
};

export type MerchantProductVariantImageMatch = {
    imageUrl: string;
    selections: {
        optionID: string;
        label: string;
        value: {
            id: string;
            label: string;
        };
    }[];
};

/**
 * Given a list of selected attribute => option return a list of combinations (only of different attributes)
 * @param selectedAttributesOptions the list of selected attributes => options
 */
export const buildCombinations = (selectedAttributesOptions: SelectedAttributeOption[]) => {
    const combinations: SelectedAttributeOption[][] = [];
    const data: SelectedAttributeOption[] = [];
    const numberOfAttributes = _.keys(_.groupBy(selectedAttributesOptions, (item) => item.Id)).length;

    const addCombination = (start: number, end: number, index: number) => {
        // Current combination is ready to be printed, print it
        if (index == numberOfAttributes) {
            combinations.push(_.clone(data));
            return;
        }

        for (let i = start; i <= end && end - i + 1 >= numberOfAttributes - index; i++) {
            if (index > 0) {
                let value = selectedAttributesOptions[i];
                let valuePrev = data[index - 1];

                if (value.Id == valuePrev.Id) continue;
            }

            data[index] = selectedAttributesOptions[i];
            addCombination(i + 1, end, index + 1);
        }
    };

    addCombination(0, selectedAttributesOptions.length - 1, 0);
    return combinations;
};

/** Type guard for the selected attribute option */
const isSelectedOptionValue = (optionValue: string | SelectedAttributeOption[]): optionValue is SelectedAttributeOption[] => Array.isArray(optionValue);

/**
 * Given two attributes/options list, return true if they match.
 * @param attributeCode1 First attributes/options list
 * @param attributeCode2 Second attributes/options list
 */
export const matchColorsAttributes = (attributeCode1: string | SelectedAttributeOption[], attributeCode2: string | SelectedAttributeOption[]) => {
    const attributes1 = isSelectedOptionValue(attributeCode1) ? attributeCode1 : (JSON.parse(attributeCode1) as SelectedAttributeOption[]);

    const attributes2 = isSelectedOptionValue(attributeCode2) ? attributeCode2 : (JSON.parse(attributeCode2) as SelectedAttributeOption[]);

    if (attributes1.length != attributes2.length) return false;

    for (const attribute1 of attributes1) {
        let found = false;

        for (const attribute2 of attributes2) {
            if (attribute1.Id == attribute2.Id && attribute1.Value.Id == attribute2.Value.Id) {
                found = true;
                break;
            }
        }

        if (found == false) return false;
    }

    return true;
};
